<template>
  <div class="team-momfident">
    <div class="container">
      <div class="row">
        <div v-for="(member, index) in teamMembers" :key="index" class="col-md-3 mb-4">
          <div class="item">
            <div class="image" v-bind:style="{ 'background-image': `url(${member.image})` }"></div>
            <div class="name-container">
              <div class="first-name">{{ member.firstName }}</div>
              <div class="last-name">{{ member.lastName }}</div>
            </div>
            <div class="title">{{ member.title }}</div>
            <div class="description" v-html="member.description"></div>
            <div class="linkedin-icon" v-if="member.linkedin">
              <a :href="member.linkedin" target="_blank" rel="noopener noreferrer">
                <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.30554 1.12282C10.8501 1.32681 15.8444 0.746765 20.3391 1.10736C23.4734 1.35871 26.1183 3.82968 26.3761 6.83042C26.7396 11.0647 26.1091 15.7495 26.3761 20.0312C26.0817 23.1035 23.5708 25.4613 20.3513 25.7658C15.8525 25.5116 10.9303 26.1119 6.48119 25.7658C3.28805 25.5174 0.731502 23.0532 0.456354 20.0312C0.674645 15.7717 0.1609 11.2455 0.450262 7.01797C0.662462 3.90025 3.06163 1.50855 6.30554 1.12282ZM6.90965 5.74575C4.59475 6.0609 4.8435 9.72386 7.6691 9.26273C9.77688 8.91954 9.48345 5.39579 6.90965 5.74575ZM21.4153 21.0443V14.0568C21.4153 13.5231 20.8945 12.2519 20.5036 11.841C19.3472 10.6239 16.2637 10.563 14.9438 11.5597C14.6493 11.782 14.493 12.0469 14.226 12.2741V10.9245H11.3902V21.0443H14.428V15.4063C14.428 15.2062 14.6605 14.5005 14.7773 14.2926C15.0047 13.8886 15.4372 13.5318 15.9205 13.4535C17.1835 13.2495 17.9927 13.7667 18.2527 14.9471C18.2791 15.066 18.3775 15.7099 18.3775 15.7921V21.0443H21.4153ZM9.06109 10.9255H5.41512V21.0453H9.06109V10.9255Z" fill="#6B6B9C"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

// Define props
defineProps({
  teamMembers: {
    type: Array,
    required: true
  }
});
</script>

<style lang="scss" scoped>
.team-momfident {
  background: $color-pink-light;
  color: $color-purple;
  padding: 30px 0;

  .item {
    background: #fff;
    border-radius: 40px;
    padding: 30px;
    position: relative;
    padding-bottom: 60px; /* Space for the LinkedIn icon */
    height: 100%;

    .image {
      padding-top: 70%;
      width: 100%;
      background-size: cover;
      border-radius: 30px;
    }

    .name-container {
      margin: 10px 0;

      .first-name, .last-name {
        color: #FF95AA;
        font-family: $font-regular;
        font-size: 28px;
        line-height: 1.2;
      }
    }

    .title {
      color: #FF95AA;
      font-family: $font-regular;
      font-size: 16px;
      line-height: 1.2;
      margin-bottom: 10px;
    }

    .description {
      font-size: 14px;
    }

    .linkedin-icon {
      position: absolute;
      bottom: 20px;
      left: 30px;
    }
  }
}
</style>
